// GenericTabs.jsx
import React from "react";
import * as Tabs from "@radix-ui/react-tabs";
import { GenComponentName } from "../../../utils/GenComponentNames";// Import the tab component
import { useTabValue } from "../../../store/plateWellStore";
import { usePlateWellActions } from "../../../store/plateWellStore";

const GenericTabs = ({ tabsData, tabValue }) => {

    const { setSelectedAnanlysisType, setTabValue } = usePlateWellActions();

    const handleClearState = (newTabValue) => {
        if (newTabValue === "tab3") {
            //setSelectedAnanlysisType("");
        }
        //setAnalysisResults([]);
        setTabValue(newTabValue);
    };

    // const tabValue = useTabValue();
    return (
        <Tabs.Root className="flex flex-col  shadow-[0_2px_10px] shadow-blackA2" defaultValue={tabValue} onValueChange={(value) => handleClearState(value)}>
            <Tabs.List className="shrink-0 flex border-b border-mauve6" aria-label="Tabs List">
                {tabsData.map((tab, index) => (
                    <Tabs.Trigger key={crypto.randomUUID()} className="text-custom-green bg-white px-5 h-[45px] flex-1 flex items-center justify-center text-[15px] 
                       leading-none select-none first:rounded-tl-md last:rounded-tr-md hover:text-violet11 
                       data-[state=active]:text-violet11 data-[state=active]:shadow-[inset_0_-1px_0_0,0_1px_0_0] 
                       data-[state=active]:shadow-current data-[state=active]:focus:relative data-[state=active]:focus:shadow-[0_0_0_2px]
                       data-[state=active]:focus:shadow-black outline-none cursor-default" value={`tab${index + 1}`}>
                        {tab.label}
                    </Tabs.Trigger>
                ))}
            </Tabs.List>

            {
                tabsData.map((tab, index) => (
                    <Tabs.Content key={crypto.randomUUID()} className="grow p-5 bg-white rounded-b-md outline-none focus:shadow-[0_0_0_2px]
                                    focus:shadow-black" value={`tab${index + 1}`}>
                        {GenComponentName(tab.label, tab.content)}
                    </Tabs.Content>
                ))

            }
        </Tabs.Root >
    );
};


export default GenericTabs;
